var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDirections9 = function SvgIconDirections9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.542 5.301A7.25 7.25 0 0 0 7.64 6.876h-.001l-1.475 1.47h2.081a1 1 0 1 1 0 2H3.747a1.1 1.1 0 0 1-.354-.063 1 1 0 0 1-.64-.811 1 1 0 0 1-.008-.137V4.847a1 1 0 1 1 2 0v2.09l1.48-1.475a9.25 9.25 0 1 1 0 13.076 1 1 0 0 1 1.415-1.414 7.25 7.25 0 1 0 7.902-11.823"
  })));
};
export default SvgIconDirections9;